// Use IIFE to prevent duplicate execution
(function() {
  // Check if already initialized
  if (window.LYWishlistInitialized) {
    return;
  }
  window.LYWishlistInitialized = true;

  class LYWishlist extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.wishlistButton = this.querySelector('.wishlist-button');
      const empiValue = this.wishlistButton && this.wishlistButton.dataset && this.wishlistButton.dataset.productEmpi;
      const epi = this.wishlistButton && this.wishlistButton.dataset && this.wishlistButton.dataset.productEpi;

      const empi = empiValue ? empiValue : '';
      if (empi) {
        this.actionButton = document.querySelector(`.wishlist-action-btn[data-product-empi="${empi}"]`);

        if (this.wishlistButton) {
          this.wishlistButton.addEventListener('click', () => this.onClick(this.wishlistButton));
        }

        if (this.actionButton) {
          this.actionButton.addEventListener('click', () => this.onClick(this.wishlistButton));
        }

        (async () => {
          while (!window.hasOwnProperty('_swat'))
            await new Promise(resolve => setTimeout(resolve, 1000));

          if (window.wishlistItems === undefined) {
            let wishlistItems = [];
            window._swat.fetch(
              (data) => {
                data.forEach((element) => {
                  wishlistItems.push(element.empi);
                });

                if (wishlistItems.includes(Number(empi)) || wishlistItems.includes(Number(epi))) {
                  this.wishlistButton.classList.add('wishlist-added');
                }

                window.wishlistItems = wishlistItems;

                this.updateButtonState();
                this.setupObserver();
              });
          } else {
            if (window.wishlistItems.includes(Number(empi)) || window.wishlistItems.includes(Number(epi))) {
              this.wishlistButton.classList.add('wishlist-added');
            }

            this.updateButtonState();
            this.setupObserver();
          }
        })();
      }
    }

    setupObserver() {
      const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.updateButtonState();
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(this.wishlistButton, { attributes: true });
    }

    updateButtonState() {
      let actionText;

      if (this.wishlistButton.classList.contains('wishlist-added')) {
        actionText = window.lyT('wishlistRemove', 'Remove from Wishlist');
      } else {
        actionText = window.lyT('wishlistAdd', 'Add to Wishlist');
      }

      if (this.actionButton) {
        this.actionButton.innerText = actionText;
      }
    }

    onClick(wishlistButton) {
      let wishlistPage = document.querySelector('.wishlist-page');
      let isWishlistPage = wishlistPage != null;
      wishlistButton = this.wishlistButton;
      let epi = wishlistButton.dataset.productEpi;
      let iu = wishlistButton.dataset.productIu;
      let du = wishlistButton.dataset.productDu;
      let empi = wishlistButton.dataset.productEmpi;

      let wishlistItems = [];

      window._swat.fetch(
        function (data) {
          data.forEach((element) => {
            wishlistItems.push(element.empi);
          });

          if (!wishlistItems.includes(Number(empi))) {
            window._swat.addToWishList(
              {
                epi: epi,
                du: du,
                empi: empi,
                iu: iu,
              },
              function (r) {
                wishlistButton.classList.add('wishlist-added');
                if (this.actionButton) {
                  this.actionButton.innerText = window.lyT('wishlistRemove', 'Remove from Wishlist');
                }
              }.bind(this),
            );
          } else {
            window._swat.removeFromWishList(
              {
                epi: epi,
                du: du,
                empi: empi,
                iu: iu,
              },
              function (r) {
                wishlistButton.classList.remove('wishlist-added');
                if (this.actionButton) {
                  this.actionButton.innerText = window.lyT('wishlistAdd', 'Add to Wishlist');
                }
                if (isWishlistPage) {
                  wishlistButton.closest('.grid__item').remove();
                }
              }.bind(this),
            );
          }
        }.bind(this),
      );
    }
  }

  // Only define if not already defined
  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', LYWishlist);
  }
})();
